import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MuiAutocomplete from "../components/autocomplete/MuiAutocomplete";
import { Question } from "../exam/type";

// Props interface for the form component
interface QuestionUpdateFormProps {
  initialQuestion: Question;
  onSubmit: (question: Question) => void;
  isLoading: boolean;
  open: boolean;
  onClose: () => void;
}

// Interface for form errors
interface FormErrors {
  [key: string]: string;
}

const QuestionUpdateForm: React.FC<QuestionUpdateFormProps> = ({
  initialQuestion,
  onSubmit,
  isLoading,
  open,
  onClose,
}) => {
  // State for the form
  const [question, setQuestion] = useState<Question>(initialQuestion);

  // Form validation errors
  const [errors, setErrors] = useState<FormErrors>({});

  // Initialize form with question data if available
  useEffect(() => {
    if (initialQuestion) {
      setQuestion(initialQuestion);
    }
  }, [initialQuestion]);

  // Handle input changes
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    // Handle number fields
    if (name === "sectionOrder" || name === "number" || name === "imageId") {
      setQuestion((prev) => ({
        ...prev,
        [name]: value === "" ? undefined : Number(value),
      }));
    } else {
      setQuestion((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error when field is edited
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  // Validate form before submission
  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};

    if (!question.content) newErrors.content = "Question content is required";
    if (!question.answer) newErrors.answer = "Answer is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      onSubmit(question);
    }
  };

  console.log(question);
  return (
    <Dialog
      open={open}
      maxWidth="md"
      onClose={() => {
        setQuestion(initialQuestion);
        onClose();
      }}
    >
      <DialogTitle>Soru {initialQuestion.number} Güncelle</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <MuiAutocomplete
                onChange={(e, value) => {
                  setQuestion((prev) => ({
                    ...prev,
                    examTypeCategoryCode: value?.categoryCode,
                  }));
                }}
                name="examTypeCategoryCode"
                dataItemKey="categoryCode"
                dataTextValue="categoryName"
                url={`/api/examTypeCategories?filters[0].field=examTypeCode&filters[0].operator=eq&filters[0].value=${question.examTypeCode}`}
                label="Kategori"
                value={question.examTypeCategoryCode}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControlLabel
                control={
                  <Switch
                    name="canceled"
                    checked={question.canceled}
                    onChange={(e, checked) =>
                      setQuestion({ ...question, canceled: checked })
                    }
                  />
                }
                label="İptal"
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                name="content"
                label="Soru"
                fullWidth
                multiline
                rows={4}
                value={question.content}
                onChange={handleChange}
                error={!!errors.content}
                helperText={errors.content}
                required
              />
            </Grid>

            {/* Question Answer */}
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <InputLabel id="cevap-label">Cevap</InputLabel>
                <Select
                  labelId="cevap-label"
                  id="answer"
                  name="answer"
                  value={question.answer}
                  label="Cevap"
                  onChange={(e) => {
                    setQuestion((prev) => ({
                      ...prev,
                      answer: e.target.value,
                    }));
                  }}
                >
                  {initialQuestion.options.map((option) => (
                    <MenuItem key={option.option} value={option.option}>
                      {option.option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Question Explanation */}
            <Grid size={{ xs: 12 }}>
              <TextField
                name="explanation"
                label="Açıklama"
                fullWidth
                multiline
                rows={3}
                value={question.explanation || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isLoading}
            >
              {isLoading ? "Kaydediliyor..." : "Güncelle"}
            </Button>
          </DialogActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default QuestionUpdateForm;
